import React from 'react';
import { Link } from 'react-router';
import Layout from '../layouts/claire';
import { generateRandomId, formatCurrency, padWithZeros } from '../../helpers';
import { Animated } from 'react-animated-css';
import Menu from '../partials/menu';
import { Popover, PopoverBody, Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import TopRightMenu from '../partials/top_right_menu';
import moment from 'moment';
import fakeAuth from '../../fakeAuth';
import _ from 'lodash';
import LineLoader from '../partials/line_loader';
import request from 'superagent';
import DatePicker from 'react-datepicker';
import CustomDatePicker from '../partials/custom_date_picker';
import config from '../../config';
import conversionRates from '../../conversionRates';
import eventBus from '../../redux-sagas/events/bus';

class AddBooking extends React.Component {
    state = {
        mode: localStorage.getItem('lb.rt') || 'items',
        files: [],
        validations: {},
        menu_toggled: false,
        filters: {
            CheckIn: moment().utc()
        },
        hotel_name: localStorage.getItem('lb.ip') ? JSON.parse(localStorage.getItem('lb.ip')).Name : null,
        bootstrapped: false,
        sources: [{ id: 1, value: 'Source 1' }, { id: 2, value: 'Source 2' }],
        staff: {
            IdProperty: this.props.params.id,
            PhoneCountryCode: '+58',
            CellphoneCountryCode: '+58',
        },
        source: 'WEB',
        cart: [],
        currency: localStorage.getItem('lb.currency') || 'USD',
        rate_types: [],
        preselect: null, // habitacion elegida desde el Rack: { IdRoom, IdPiece, Label }
        preselect_check: null, // { free, conflict } para la estadia buscada
    }

    // lifecycle
    componentWillMount() {
        const { params } = this.props;
        this.props.form_actions.fetch_countries();
        this.props.logic_actions?.fetch_conversion_rates();
        eventBus.on('lb.event.currency_change', this.onCurrencyChange);
        this.fetchRateTypes();

        // Viene del Rack: /booking/add/:id?checkin=YYYY-MM-DD&room=IdRoom&piece=IdPiece&label=101
        const { checkin, room, piece, label } = this.props.location?.query || {};
        if (checkin && moment(checkin, 'YYYY-MM-DD', true).isValid() && room) {
            this.setState({
                CheckIn: moment(checkin, 'YYYY-MM-DD').utc(),
                preselect: { IdRoom: room, IdPiece: piece || null, Label: label || '' }
            });
        }
    }
    componentDidMount = () => {
        if (this.state.preselect) {
            this.txtNights.value = 1;
            this.onSearch();
        }
    }

    fetchRateTypes = () => {
        request.get(`${config.apiEndpoint}/api/v4/settings/rate_types/${this.props.params.id}`)
            .set('auth_token', localStorage.getItem('legendbeds.authtoken'))
            .then((data) => {
                if (data.body.success) {
                    const rate_types = data.body.rate_types;
                    this.setState({ rate_types }, () => {
                        // migrate old numeric lb.rt to Code
                        const stored = localStorage.getItem('lb.rt');
                        if (!rate_types.find(rt => rt.Code === stored)) {
                            localStorage.setItem('lb.rt', 'items');
                            this.setState({ mode: 'items' });
                        }
                    });
                }
            });
    }
    componentWillReceiveProps = nextProps => {

    }
    componentWillUnmount = () => {
        eventBus.off('lb.event.currency_change', this.onCurrencyChange);
    }
    //

    onCurrencyChange = () => {
        this.setState({ currency: localStorage.getItem('lb.currency') || 'USD' });
    }
    onSaveBook = () => {
        let { currency } = this.state;
        let rates = conversionRates.R();
        let ConversionRate = currency === 'USD' ? 1 : (rates.usd ?? 1);

        // validate
        if (this.state.microTransac) return;
        const { cart } = this.state;
        if (!cart.length) {
            alert('Please add at least one room');
            return;
        }
        this.setState({ saving: true, microTransac: true }, () => {

            let current_array = this.state.mode || 'items';
            const rateType = this.state.rate_types.find(rt => rt.Code === current_array);

            // TODO: the idea here is to send all
            // the cart to the API, and generate a booking ID,
            // then redirect to the 'booking' page, for them to complete guest information (or delete it if is not compeltes?)
            // Call API
            request.post(`${config.apiEndpoint}/api/v4/bookings/${this.props.params.id}`)
                .set('auth_token', localStorage.getItem('legendbeds.authtoken'))
                .send({
                    IdAccount: fakeAuth.getUser().IdAccount,
                    Cart: this.state.cart,
                    RateHeader: {
                        id: rateType ? rateType.IdRateType : current_array,
                        name: current_array
                    },
                    IsGroup: this.state.group ? 1 : 0,
                    Source: this.state.source,
                    CheckIn: moment(this.state.CheckIn).utc().format(),
                    CheckOut: moment(this.state.CheckOut).utc().format(),
                    ConversionRate
                })
                .then((data) => {

                    if (data.body.success) {
                        let ID = data.body.IdBook;
                        this.props.router.push(`/booking/${ID}`);
                    } else
                        this.setState({ microTransac: false });

                }, (error) => {
                    this.setState({ microTransac: false, error: 'Something wrong' });
                    //this.props.setDeveloperMessage && this.props.setDeveloperMessage(error);
                });
        });
    }

    // Verifica que la habitacion elegida en el Rack este libre todas las noches de la estadia buscada
    checkPreselect = (CheckIn, CheckOut) => {
        const { preselect } = this.state;
        if (!preselect || !preselect.IdPiece) return Promise.resolve();
        const from = moment(CheckIn).format('YYYY-MM-DD'), to = moment(CheckOut).format('YYYY-MM-DD');

        return request.post(`${config.apiEndpoint}/api/v4/logic/occupancy/range/${this.props.params.id}`)
            .set('auth_token', localStorage.getItem('legendbeds.authtoken'))
            .send({ CheckIn: from, CheckOut: to })
            .then(data => {
                // Misma regla que la disponibilidad: sólo reservas vivas (por confirmar, confirmadas, check-in) que se solapen con las noches
                const conflict = _.chain(data.body.bookings || [])
                    .filter(b => !b.IsQuote && [1, 2, 3].indexOf(b.IdStatus) !== -1)
                    .filter(b => moment(b.CheckIn).utc().format('YYYY-MM-DD') < to && moment(b.CheckOut).utc().format('YYYY-MM-DD') > from)
                    .find(b => _.find(b.Rooms, r => r.IdPiece === preselect.IdPiece))
                    .value();
                this.setState({ preselect_check: { free: !conflict, conflict } });
            }, () => this.setState({ preselect_check: { free: false, error: true } }));
    }

    // Cuando ya se conocen las tarifas del tipo elegido en el Rack, lo agrega al carrito una sola vez por busqueda
    applyPreselect = (index) => {
        (this.preselectCheck || Promise.resolve()).then(() => {
            const { preselect, rooms } = this.state, room = rooms && rooms[index];
            if (!preselect || !room || room.IdRoom !== preselect.IdRoom || this.preselectApplied) return;
            if (room.BOOKABLE > 0 && room.MIN_RATE >= 0) {
                this.preselectApplied = true;
                this.addToCart(index);
            }
        });
    }

    // Descarta la habitacion del Rack: el carrito conserva el tipo pero sin habitacion asignada
    onDismissPreselect = () => {
        const cart = _.map(this.state.cart, item => _.omit(item, 'IdPiece', 'PieceLabel'));
        this.setState({ preselect: null, preselect_check: null, cart });
    }

    // Agrega al carrito el tipo de habitacion rooms[i] con los adultos/niños/infantes seleccionados
    addToCart = (i) => {
        const { cart, rooms, mode } = this.state;
        let current_array = mode || 'items';
        let room_to_add = { ...rooms[i] };

        // RULE: at least one (1) adult per room
        if (!room_to_add.SELECTED_ADULTS) room_to_add.SELECTED_ADULTS = 1;
        //

        let ADULT_RATE = 0, CHILDREN_RATE = 0, CRIBS_RATE = 0;


        // Adding up adults                                        
        if (room_to_add.SELECTED_ADULTS) {
            ADULT_RATE = _.chain(room_to_add.RATE)
                .map(day => {
                    return parseFloat((_.find((day.DAY_RATE[current_array] || day.DAY_RATE.items), i => i.Amount === room_to_add.SELECTED_ADULTS) || { Adults: 0 }).Adults);
                })
                .reduce((a, b) => a + b, 0)
                .value();
        }
        //

        // Adding up children                                        
        if (room_to_add.SELECTED_CHILDREN) {
            CHILDREN_RATE = _.chain(room_to_add.RATE)
                .map(day => {
                    return parseFloat((_.find((day.DAY_RATE[current_array] || day.DAY_RATE.items), i => i.Amount === room_to_add.SELECTED_CHILDREN) || { Children: 0 }).Children);
                })
                .reduce((a, b) => a + b, 0)
                .value();
        }
        //

        // Adding up cribs                                        
        if (room_to_add.SELECTED_CRIBS) {
            CRIBS_RATE = _.chain(room_to_add.RATE)
                .map(day => {
                    return parseFloat((_.find((day.DAY_RATE[current_array] || day.DAY_RATE.items), i => i.Amount === room_to_add.SELECTED_CRIBS) || { Cribs: 0 }).Cribs);
                })
                .reduce((a, b) => a + b, 0)
                .value();
        }
        //


        room_to_add.ADULT_RATE = ADULT_RATE; // * room_to_add.SELECTED_QUANTITY;
        room_to_add.CHILDREN_RATE = CHILDREN_RATE; // * room_to_add.SELECTED_QUANTITY;
        room_to_add.CRIBS_RATE = CRIBS_RATE; // * room_to_add.SELECTED_QUANTITY;
        room_to_add.CALCULATED_RATE = ADULT_RATE + CHILDREN_RATE + CRIBS_RATE;

        // Habitacion elegida desde el Rack: se asocia al primer item del tipo que la contiene, si esta libre toda la estadia
        const { preselect, preselect_check } = this.state;
        const piece = (preselect && preselect.IdPiece && preselect_check && preselect_check.free && room_to_add.IdRoom === preselect.IdRoom
            && !_.find(cart, c => c.IdPiece === preselect.IdPiece)) ? { IdPiece: preselect.IdPiece, PieceLabel: preselect.Label } : {};

        for (let j = 1; j <= parseInt({ ...room_to_add }.SELECTED_QUANTITY || 1, 10); j++) {
            cart.push({ ...room_to_add, SELECTED_QUANTITY: 1, local_id: generateRandomId(5), ...(j === 1 ? piece : {}) });
        }
        this.setState({ cart });
    }

    onSort = (s) => {
        const { sort } = this.state;
        if (s === sort) this.setState({ up: !this.state.up });
        else this.setState({ up: false, sort: s });
    }
    onSearch = () => {
        const { CheckIn, CheckOut, validations, mode } = this.state;
        let current_array = mode || 'items';

        this.preselectApplied = false;
        this.preselectCheck = null;
        this.setState({ validations: {}, cart: [], preselect_check: null }, () => {
            const { validations, property } = this.state;

            let Nights = this.txtNights.value ? (parseInt(this.txtNights.value, 10) || 1) : 1;

            if (!CheckIn) {
                validations.txtCheckIn = 'Por favor, selecciona la fecha de check-in';
                this.setState({ validations });
                return;
            }

            this.setState({ microTransac: true, CheckOut: moment(CheckIn).add(Nights, 'days') }, () => {
                request.post(`${config.apiEndpoint}/api/v4/logic/availability/${this.props.params.id}`)
                    .set('auth_token', localStorage.getItem('legendbeds.authtoken'))
                    .send({ CheckIn, CheckOut: this.state.CheckOut })
                    .then((data) => {
                        if (data.body.success) {
                            this.preselectCheck = this.checkPreselect(CheckIn, this.state.CheckOut);
                            this.setState({ rooms: data.body.rooms, microTransac: false, bootstrapped: true }, () => {
                                this.state.rooms.forEach((room, index) => {
                                    request.post(`${config.apiEndpoint}/api/v4/logic/rates/${room.IdRoom}`)
                                        .set('auth_token', localStorage.getItem('legendbeds.authtoken'))
                                        .send({ CheckIn, CheckOut: this.state.CheckOut })
                                        .then((data) => {
                                            const { rooms } = this.state;
                                            rooms[index].RATE = data.body.rates;
                                            rooms[index].MIN_RATE = 0;
                                            rooms[index].RATE.forEach(rate => {
                                                if (rate.DAY_RATE) {
                                                    rooms[index].MIN_RATE += parseFloat((rate.DAY_RATE[current_array] || rate.DAY_RATE.items)[0].Adults);
                                                }
                                            });
                                            this.setState({ rooms });
                                            if (this.state.preselect && rooms[index].IdRoom === this.state.preselect.IdRoom) this.applyPreselect(index);
                                        });
                                });
                            });
                        } else {
                            // TODO: show server error?
                            this.setState({ microTransac: false });
                        }
                    }, (error) => {
                        this.setState({ microTransac: false, error: 'Something wrong' });
                        //this.props.setDeveloperMessage && this.props.setDeveloperMessage(error);
                    });
            });

        });
    }

    renderHeader = () => {
        return <div className="d-flex">
            <div className="w-100 d-flex ">
                <i className="icon-lb_reservaciones white font-40 align-self-center" />
                <div className="align-self-center d-flex flex-column">
                    <span className="white ms-3 font-20 line1 poppins">Nueva reserva</span>
                    <Link to="/properties" className="white ms-3 font-10 poppins underlined">{this.state.hotel_name}</Link>
                </div>
                <button onClick={() => this.props.router && this.props.router.goBack()} type="button" className="btn btn-lg btn-blue white ms-3 align-self-center" >
                    <i className="icon-corner-down-left white font-12" />
                </button>
            </div>
            <div className="w-75">
                <TopRightMenu {...this.props} />
            </div>
        </div>
    }
    renderFilters = () => {
        const { filters, sources, validations, mode } = this.state;
        return <Animated animationIn="fadeInRight" className="w-100 d-flex flex-wrap mt-4" style={{ zIndex: 200, position: 'relative' }}>

            {/* Start */}
            <div style={{ width: 150 }}>
                <label className="white poppins font-12">Check-in</label>
                <div id="txtCheckIn">
                    <DatePicker highlightDates={[]} customInput={<CustomDatePicker format="DD/MM/YYYY" hint="Check-In" />} selected={this.state.CheckIn} showYearDropdown scrollableYearDropdown
                        yearDropdownItemNumber={15} onChange={date => {
                            this.setState({ CheckIn: moment(date).utc() });
                        }} className={`${validations.txtCheckIn ? 'error-input' : ''} white font-12`}
                    />
                    <Popover placement="right" isOpen={validations.txtCheckIn ? true : false} target={`txtCheckIn`} toggle={() => {
                        const { validations } = this.state;
                        validations.txtCheckIn = !validations.txtCheckIn;
                        this.setState({ validations });
                    }} className="bg-gray-2">
                        <PopoverBody className="d-flex flex-row justify-content-center">
                            <i className="fas fa-times red font-8 align-self-center" />
                            <span className="white font-8 poppins align-self-center ms-3" style={{ maxWidth: 100 }}>{validations.txtCheckIn}</span>
                        </PopoverBody>
                    </Popover>
                </div>
            </div>
            <div className="p-1" />
            {/* Nights */}
            <div style={{ width: 150 }}>
                <label className="white poppins font-12">Noches</label>
                <div id="txtNights" className={`black-input d-flex mt-2`}>
                    <input className="w-100 p-3 white" type="text" name="nights" placeholder="Noches" ref={(input) => this.txtNights = input} />
                </div>
            </div>
            <div className="p-1" />
            <button onClick={this.onSearch} className="btn btn-lg btn-blue align-self-end d-flex">
                <i className={`fas fa-${this.state.microTransac ? 'clock fa-spin' : 'search'} white font-18 my-2 align-self-center`} />
            </button>
            <button onClick={() => this.setState({ group: !this.state.group })} className="btn btn-lg btn-link align-self-end d-flex">
                <i className={`far fa-${this.state.group ? 'check-square blue' : 'square gray'} font-18 align-self-center my-2`} />
                <span className="ms-2 align-self-center white font-12">Empresarial | Grupal</span>
            </button>

            {/* Source */}
            <div className="ms-auto" style={{ width: 200 }}>
                <label className="white poppins font-12">Fuente</label>
                <div id="txtType" className={`black-input  d-flex mt-2`}>
                    <Dropdown isOpen={this.state.pickSource} toggle={() => this.setState({ pickSource: !this.state.pickSource })} className="w-100">
                        <DropdownToggle style={{ paddingTop: 0, paddingBottom: 0, backgroundColor: 'transparent' }} className="w-100 p-3 white bg-transparent d-flex">
                            <span className="align-self-center">{(_.find(config.book_sources, t => t.name === this.state.source)).name}</span>
                            <i className="fas fa-chevron-down font-16 white align-self-center ps-3 ms-auto" />
                        </DropdownToggle>
                        <DropdownMenu className="w-100" style={{ maxHeight: 300, overflowY: 'auto' }}>
                            {config.book_sources.map((c, i) => <DropdownItem key={i} onClick={() => {
                                this.setState({ source: c.name });
                            }}>{c.name}</DropdownItem>)}
                        </DropdownMenu>
                    </Dropdown>
                </div>
            </div>

            {/* Rate type */}
            <div className="ms-2" style={{ width: 200 }}>
                <label className="white poppins font-12">Tarifa</label>
                <div id="txtType" className={`black-input  d-flex mt-2`}>
                    <Dropdown isOpen={this.state.pickType} toggle={() => this.setState({ pickType: !this.state.pickType })} className="w-100">
                        <DropdownToggle style={{ paddingTop: 0, paddingBottom: 0, backgroundColor: 'transparent' }} className="w-100 p-3 white bg-transparent d-flex">
                            <span className="align-self-center">{(_.find(this.state.rate_types, t => t.Code === mode) || {}).Name || mode}</span>
                            <i className="fas fa-chevron-down font-16 white align-self-center ps-3 ms-auto" />
                        </DropdownToggle>
                        <DropdownMenu className="w-100" style={{ maxHeight: 300, overflowY: 'auto' }}>
                            {this.state.rate_types.map((c, i) => <DropdownItem key={i} onClick={() => {
                                this.setState({ mode: c.Code }, () => {
                                    localStorage.setItem('lb.rt', c.Code);
                                    this.onSearch();
                                });
                            }}>{c.Name}</DropdownItem>)}
                        </DropdownMenu>
                    </Dropdown>
                </div>
            </div>
        </Animated>
    }
    renderPreselect = () => {
        const { preselect, preselect_check, rooms, bootstrapped } = this.state;
        if (!preselect) return null;

        const type = _.find(rooms, r => r.IdRoom === preselect.IdRoom), label = preselect.Label ? `Habitación ${preselect.Label}` : 'La habitación';
        let tone = 'blue', icon = 'fa-clock fa-spin', text = 'Preparando la reserva desde el Rack...';

        if (bootstrapped && (!type || !(type.BOOKABLE > 0))) {
            tone = 'red'; icon = 'fa-times-circle';
            text = type ? `No hay disponibilidad de ${type.GivenName} para las fechas seleccionadas.` : `${label} no está disponible para la venta en estas fechas.`;
        } else if (bootstrapped && (preselect_check || !preselect.IdPiece)) {
            if (preselect_check && preselect_check.error) {
                tone = 'orange'; icon = 'fa-exclamation-triangle';
                text = `No se pudo verificar ${label}. Se reservará ${type.GivenName} y podrás asignar la habitación después.`;
            } else if (preselect_check && !preselect_check.free) {
                const c = preselect_check.conflict;
                tone = 'orange'; icon = 'fa-exclamation-triangle';
                text = `${label} no está libre toda la estadía${c ? ` (reserva #${padWithZeros(c.PNR)} del ${moment(c.CheckIn).utc().format('DD/MM')} al ${moment(c.CheckOut).utc().format('DD/MM')})` : ''}. Se reservará ${type.GivenName} y podrás asignar otra habitación después.`;
            } else {
                tone = 'green'; icon = 'fa-check-circle';
                text = `${label} (${type.GivenName}) seleccionada desde el Rack. Se asignará a la reserva al crearla.`;
            }
        }

        return <div className="d-flex bg-gray-3 black-input p-3 mt-4" style={{ borderRadius: 6 }}>
            <i className={`fas ${icon} ${tone} align-self-center me-3`} />
            <span className="poppins white font-10 align-self-center">{text}</span>
            <button title="Quitar la habitación elegida" className="btn btn-link gray ms-auto align-self-center" onClick={this.onDismissPreselect}><i className="fas fa-times" /></button>
        </div>
    }
    renderTH = () => {
        const { sort } = this.state;
        return <thead>
            <tr>
                <th className="bg-gray-2 white">Tipo <i className={`icon-lb_sort ${sort === 'Name' ? 'blue' : 'gray'}`}
                    onClick={() => this.onSort('Name')} /></th>
                <th className="bg-gray-2 white">Desde <i className={`icon-lb_sort ${sort === 'IdBooking' ? 'blue' : 'gray'}`}
                    onClick={() => this.onSort('IdBooking')} /></th>
                <th className="bg-gray-2 white">Disp. <i className={`icon-lb_sort ${sort === 'Rooms' ? 'blue' : 'gray'}`}
                    onClick={() => this.onSort('Rooms')} /></th>
                <th className="bg-gray-2 white text-center">Adultos </th>
                <th className="bg-gray-2 white text-center">Niños   </th>
                <th className="bg-gray-2 white text-center">Infantes</th>
                <th className="bg-gray-2 white text-center">Cama<br />extra</th>
                <th className="bg-gray-2 white text-center">Cantidad</th>
                <th className="bg-gray-2 white text-right"></th>
            </tr>
        </thead>
    }
    renderAvailability = () => {
        const { bootstrapped, rooms, mode, currency } = this.state;
        let rates = conversionRates.R();
        let conversionRate = currency === 'USD' ? 1 : (rates.usd ?? 1);
        let current_array = mode || 'items';

        return <Animated animationInDelay={200} animationIn="fadeInRight" className="mt-4" style={{ zIndex: 100, position: 'relative' }}>
            <hr />
            <h4 className="white poppins"><i className="far fa-calendar blue me-2" />Disponibilidad</h4>
            <div className="w-100 bg-gray-2 px-3 py-2 rounded d-flex">
                <table className="w-100 table m-0 poppins bg-gray-2 white">
                    {this.renderTH()}
                    {bootstrapped && rooms && rooms.length > 0 && <tbody>
                        {rooms.map((room, i) => <tr key={room.IdRoom}>

                            <td className="bg-gray-2 white">{room.GivenName}</td>
                            <td className={`bg-gray-2 ${room.MIN_RATE ? 'white' : 'orange'}`}>{room.RATE ? `${formatCurrency(room.MIN_RATE * conversionRate, currency)}` : 'Calculating...'}</td>
                            <td className={`bg-gray-2 ${room.BOOKABLE ? 'white' : 'red'}`}>{room.BOOKABLE}/{room.Availability}</td>

                            {/* Adults */}
                            <td className="bg-gray-2 white">
                                <div className={`black-input mx-auto d-flex`} style={{ minWidth: 80, maxWidth: 80 }}>
                                    <input onChange={e => {
                                        const { rooms } = this.state;
                                        rooms[i].SELECTED_ADULTS = parseInt(e.target.value, 10) || 0;
                                        this.setState({ rooms });
                                    }} max={room.MaxAdults} min={0} className="px-3 py-1 white w-100" type="number" placeholder="0" /><span className={`align-self-center ${room.SELECTED_ADULTS && room.SELECTED_ADULTS > room.MaxAdults ? 'red' : 'gray'} font-8 me-1`}>/ {room.MaxAdults}</span>
                                </div>
                            </td>

                            {/* Children */}
                            <td className="bg-gray-2 white">
                                <div className={`black-input mx-auto d-flex`} style={{ minWidth: 80, maxWidth: 80 }}>
                                    <input onChange={e => {
                                        const { rooms } = this.state;
                                        rooms[i].SELECTED_CHILDREN = parseInt(e.target.value, 10) || 0;
                                        this.setState({ rooms });
                                    }} max={room.MaxChildren} min={0} className="px-3 py-1 white w-100"
                                        type="number" placeholder="0" /><span className={`align-self-center ${room.SELECTED_CHILDREN && room.SELECTED_CHILDREN > room.MaxChildren ? 'red' : 'gray'} font-8 me-1`}>/ {room.MaxChildren}</span>
                                </div>
                            </td>

                            {/* Cribs */}
                            <td className="bg-gray-2 white">
                                <div className={`black-input mx-auto d-flex`} style={{ minWidth: 80, maxWidth: 80 }}>
                                    <input onChange={e => {
                                        const { rooms } = this.state;
                                        rooms[i].SELECTED_CRIBS = parseInt(e.target.value, 10) || 0;
                                        this.setState({ rooms });
                                    }} max={room.MaxCribs} min={0} className="px-3 py-1 white w-100" type="number" placeholder="0" /><span className={`align-self-center ${room.SELECTED_CRIBS && room.SELECTED_CRIBS > room.MaxCribs ? 'red' : 'gray'} font-8 me-1`}>/ {room.MaxCribs}</span>
                                </div>
                            </td>

                            <td className="bg-gray-2 white text-center">
                                {room.ExtraBed === 1 && <button onClick={() => {
                                    const { rooms } = this.state;
                                    rooms[i].EXTRA_BED_SELECTED = !rooms[i].EXTRA_BED_SELECTED;
                                    this.setState({ rooms });
                                }} className="btn btn-link"><i className={`far fa-${room.EXTRA_BED_SELECTED ? `check-square blue` : `square gray`} font-16`} /></button>}
                            </td>

                            <td className="bg-gray-2 white">
                                <div className={`black-input mx-auto d-flex`} style={{ minWidth: 80, maxWidth: 80 }}>
                                    <input onChange={e => {
                                        const { rooms } = this.state;
                                        rooms[i].SELECTED_QUANTITY = parseInt(e.target.value, 10) || 0;
                                        this.setState({ rooms });
                                    }} max={room.BOOKABLE} min={0} className="px-3 py-1 white w-100" type="number" placeholder="0" />
                                </div>
                            </td>

                            {/* && (room.SELECTED_ADULTS + room.SELECTED_CHILDREN + room.SELECTED_CRIBS) <= room.MaxOccupancy */}
                            <td className="bg-gray-2 white font-8 text-right">
                                {(_.chain([
                                    room.SELECTED_ADULTS, room.SELECTED_CHILDREN, room.SELECTED_CRIBS
                                ]).compact().flatten().reduce((a, b) => a + b, 0).value()) > room.MaxOccupancy && <span className="font-8 red">Ocupación máxima<br />excedida ({room.MaxOccupancy})</span>}
                                {room.BOOKABLE > 0 && room.MIN_RATE >= 0 && (_.chain([
                                    room.SELECTED_ADULTS, room.SELECTED_CHILDREN, room.SELECTED_CRIBS
                                ]).compact().flatten().reduce((a, b) => a + b, 0).value()) <= room.MaxOccupancy && <button onClick={() => this.addToCart(i)} className="btn btn-blue btn-sm white">Agregar</button>}
                            </td>
                        </tr>)}
                    </tbody>}
                    {!bootstrapped && <tbody>
                        <tr>
                            <td colSpan={9} className="bg-gray-2 gray-light">
                                <div className="d-flex justify-content-center" style={{ height: 200 }}>
                                    <h3 className="align-self-center gray text-center poppins">Filtra tu búsqueda para<br />ver la disponibilidad.</h3>
                                </div>
                            </td>
                        </tr>
                    </tbody>}
                    {bootstrapped && rooms && rooms.length === 0 && <tbody>
                        <tr>
                            <td colSpan={9} className="bg-gray-2 gray-light">
                                <div className="d-flex justify-content-center" style={{ height: 200 }}>
                                    <h3 className="align-self-center gray text-center poppins">Lo sentimos, no encontramos habitaciones disponibles para las fechas seleccionadas.</h3>
                                </div>
                            </td>
                        </tr></tbody>}
                </table>
            </div>
        </Animated>
    }
    renderCart = () => {
        const { cart, CheckIn, CheckOut, currency } = this.state;
        let rates = conversionRates.R();
        let conversionRate = currency === 'USD' ? 1 : (rates.usd ?? 1);

        return <Animated animationInDelay={200} animationIn="fadeInRight" className="mt-4" style={{ zIndex: 100, position: 'relative' }}>
            <hr />
            <h4 className="white poppins"><i className="icon-lb_rooms blue me-2" />Habitaciones agregadas</h4>
            <div className="w-100 bg-gray-3 ps-2 pb-2 rounded d-flex flex-wrap">

                {cart.map((item, i) => <div key={item.local_id} className={`${item.CALCULATED_RATE ? 'bg-black' : 'bg-red white'} py-2 px-3 me-2 mt-2 rounded`} style={{ minWidth: 320, maxWidth: 440 }}>
                    <div className="d-flex">
                        <span className={`poppins toBold font-12 ${item.CALCULATED_RATE ? 'blue' : 'white'} align-self-center`}>x{item.SELECTED_QUANTITY || 1} {item.GivenName}{item.PieceLabel ? ` · Hab. ${item.PieceLabel}` : ''} - {item.CALCULATED_RATE ? formatCurrency(item.CALCULATED_RATE * conversionRate, currency) : 'TARIFA INVÁLIDA'}</span>
                        <button onClick={() => {
                            const { cart } = this.state;
                            this.setState({ cart: [...cart.slice(0, i), ...cart.slice(i + 1)] });
                        }} className="btn btn-sm btn-link ms-auto text-right"><i className="fas fa-times white font-12 align-self-center" /></button>
                    </div>
                    <div>
                        <span className="poppins font-10 white">{moment(CheckIn).format('DD/MM/YYYY')} • {moment(CheckOut).format('DD/MM/YYYY')}</span>
                    </div>
                    <div>
                        <span className="poppins font-8 white">{item.SELECTED_ADULTS} Adulto(s), {item.SELECTED_CHILDREN || 0} Niño(s), {item.SELECTED_CRIBS || 0} Infante(s){item.EXTRA_BED_SELECTED ? ', C/e' : ''}</span>
                    </div>
                </div>)}

            </div>
            <div className="w-50 p-0 rounded mx-auto mt-4 d-flex" style={{ overflow: 'hidden' }}>
                <div className="w-100 d-flex flex-column bg-gray-3 py-2 m-0">
                    <span className="white align-self-center">Sub-total</span>
                    <span className="white align-self-center">{formatCurrency(_.chain(cart)
                        .map(i => i.CALCULATED_RATE)
                        .reduce((a, b) => a + b, 0).value() * conversionRate, currency)}</span>
                </div>
                {/*<div className="w-100 d-flex flex-column bg-gray-3 py-2 m-0">
                                <span className="white align-self-center">Impuestos</span>
                                <span className="white align-self-center">?</span>
                            </div>*/}
                <div className="w-100 d-flex flex-column bg-gray-3 py-2 m-0">
                    <span className="white align-self-center">Promocion</span>
                    <span className="white align-self-center">{formatCurrency(0 * conversionRate, currency)}</span>
                </div>
                <div className="w-100 d-flex flex-column bg-gray-2 py-2 m-0">
                    <span className="white align-self-center">Sub-total</span>
                    <span className="white align-self-center">{formatCurrency(_.chain(cart)
                        .map(i => i.CALCULATED_RATE)
                        .reduce((a, b) => a + b, 0).value() * conversionRate, currency)}</span>
                </div>
            </div>
        </Animated>
    }
    renderCommon = () => {
        const { cart } = this.state;
        return (
            <div>
                {this.renderHeader()}
                <section className='w3-container'>
                    <Animated animationInDuration={200} animationOutDuration={200} isVisible={this.state.toggle} animationOut="fadeOutRight" animationIn="fadeInRight" className="mt-4">
                        {this.renderFilters()}
                        {this.renderPreselect()}
                        {this.renderAvailability()}
                        {cart.length > 0 && this.renderCart()}
                        {/* Buttons */}
                        {cart.length > 0 && !_.find(cart, item => !item.CALCULATED_RATE) && <div className="d-flex justify-content-center mt-4">
                            <button onClick={() => this.props.router && this.props.router.goBack()} type="button" className="btn btn-lg btn-blue white align-self-center" >
                                <i className="icon-corner-down-left white font-12" />
                            </button>
                            <button onClick={this.onSaveBook} type="button" className="btn btn-lg btn-blue white ms-3 align-self-center d-flex" >
                                <span className="align-self-center">{`Detalles ${this.state.group ? 'del grupo | empresa' : 'del huesped'}`}</span>
                                {!this.state.saving && <i className="fas fa-book white font-12 align-self-center ms-2" />}
                                {this.state.saving && <i className="fas fa-cog fa-spin white font-12 align-self-center ms-2" />}
                            </button>
                        </div>}
                    </Animated>
                </section>
                <div style={{ height: 100 }} />
            </div>
        )
    }
    render() {
        const form = this.props.form_actions;
        return (
            <Layout router={this.props.router} nbs="home" title="legendbeds" form={this.props.form} form_actions={this.props.form_actions}>
                <section>

                    {this.state.microTransac && <LineLoader />}

                    {/* DESKTOP */}
                    <div className="w3-container w3-hide-small " style={{ marginLeft: 100 }}>
                        <div style={{ height: 50 }} />
                        {this.renderCommon()}
                    </div>
                    {/* MOBILE */}
                    {/*<div className="w3-container w3-hide-medium w3-hide-large">
                        <div style={{ height: 65 }} />
                        {this.renderCommon()}
        </div>*/}

                    <Menu {...this.state} {...this.props} />

                </section>
            </Layout>
        )
    }
}

export default AddBooking;
